import styled from 'styled-components';

export const StyledContactInfoSummary = styled.div``;
